export const getTaskColumns = (translate) => {
  return [
    {
      dataField: 'name',
      type: 'string',
      text: translate('Task Name'),
      sort: true,
      sortValue: (cell, row) => row.nameValue,
      headerStyle: { backgroundColor: '#F8F9FA', width: '20%' },
    },
    {
      dataField: 'status',
      type: 'string',
      sortValue: (cell, row) => row.statusValue,
      text: translate('Status'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '18%',
        textAlign: 'center',
      },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'assignedTo',
      type: 'string',
      sortValue: (cell, row) => row.assignedToValue,
      text: translate('Assigned To'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '10%',
        textAlign: 'center',
      },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'complexity',
      type: 'string',
      sortValue: (cell, row) => row.complexityValue,
      text: translate('Complexity'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '8%',
        textAlign: 'center',
      },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'impact',
      type: 'string',
      sortValue: (cell, row) => row.impactValue,
      text: translate('Impact'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '8%',
        textAlign: 'center',
      },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'delivery',
      type: 'date',
      sortValue: (cell, row) => row.deliveryValue,
      text: translate('Delivery'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '14%',
        textAlign: 'center',
      },
      style: { textAlign: 'center', overflow: 'visible' },
    },
    {
      dataField: 'implementation',
      type: 'date',
      sortValue: (cell, row) => row.implementationValue,
      text: translate('Implementation'),
      sort: true,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '10%',
        textAlign: 'center',
      },
      style: { textAlign: 'center', overflow: 'visible' },
    },
    {
      dataField: 'action',
      searchable: false,
      text: translate('Action'),
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '10%',
        textAlign: 'center',
      },
    },
  ];
};
